exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.department-title[data-v-b60e6444] {\n\tfont-size: 22px;\nfont-weight: 500;\nline-height: 1;\ncolor:unset;\ntext-transform:unset;\n}\n.social-deliverable-campaigns[data-v-b60e6444] {\n\twidth:100%;\n}\n.department-label[data-v-b60e6444] {\n/*color:unset;*/\ncolor: #4C9850;\ndisplay:block;\nfont-weight: 400;\nfont-size: 1em;\n}\n.plus-button[data-v-b60e6444] {\n\t\tposition: relative;\n\ttop: -4px;\n\tright: -10px;\n}\n\n", ""]);

// exports
